import { useEffect } from "react";
import { useRawTable } from "../../hooks";
import moment from "moment";

export default function Module_PsychologicalCounseling_ClosedCaseServiceEffectivenessAnalysis({
  moduleTitle = "",
  moduleData = {},
  apiData = [],
  exportData = [],
  totalRecord,
  callMainAPI,
  isResetPage,
}) {
  const { setTbData, setTbFirstIndex, renderTable } = useRawTable({
    setting: moduleData,
    nullTransfer: "-",
  });

  useEffect(() => {
    if (!isResetPage) return;

    setTbFirstIndex(0);
  }, [isResetPage]);

  useEffect(() => {
    if (!apiData) return;

    const formatDetail = (data) => {
      if (!data) return;

      data.sort(function (pre, next) {
        return new Date(pre["諮商日期"]) - new Date(next["諮商日期"]);
      });

      let groups = {};
      data.forEach((item) => {
        item["開案日期"] = item["開案日期"]
          ? moment(item["開案日期"]).format("YYYY-MM-DD")
          : "-";

        if (!groups[item["個案ID"]]) groups[item["個案ID"]] = [];
        groups[item["個案ID"]].push(item);
      });

      return Object.values(groups).map((item) => {
        const lastData = item.length > 1 ? item.pop() : null;
        return {
          ...item[0],
          "F-BSR-5": item[0]["BSR-5"],
          "F-自殺": item[0]["自殺"],
          "F-GDS-15": item[0]["GDS-15"],
          "L-BSR-5": lastData ? lastData["BSR-5"] : null,
          "L-自殺": lastData ? lastData["自殺"] : null,
          "L-GDS-15": lastData ? lastData["GDS-15"] : null,
        };
      });
    };

    const formatData = formatDetail(apiData);

    setTbData({
      raw: formatData,
      format: null,
      export: formatData,
      totalRecord: formatData.length,
    });
  }, [apiData, exportData]);

  return (
    <>
      {renderTable({
        moduleTitle: moduleData.label,
        isLazy: true,
        isPaginator: true,
        callMainAPI: null,
      })}
    </>
  );
}
